import { PoSelectOption } from "@po-ui/ng-components";

export enum InventoryStatusEnum {
    InProgress = 1,
    Calculated = 3,
    //Closed = 5,
    //Canceled = 6,
    CountingStarted = 7,
    //CountingFinished = 8
}